import React from 'react';
import styled from 'styled-components';
interface Props {
  iframeUrl: string;
}

const Component: React.FC<Props> = ({ iframeUrl }) => (
  <Container>
    <Frame src={iframeUrl} />
  </Container>
);
const MarketDataTab = React.memo(Component);
const Container = styled.div`
  width: 100%;
  height: 600px;
  margin: 25px 0 10px 0;
  background-color: #ffffff;
`;
const Frame = styled.iframe`
  width: 100%;
  height: 100%;
`;
export default MarketDataTab;
